import React from 'react';
import { ChevronUp, ChevronDown, Minus } from 'lucide-react';
interface MovementIndicatorProps {
  currentRank: number;
  previousRank: number;
}
export function MovementIndicator({
  currentRank,
  previousRank
}: MovementIndicatorProps) {
  const diff = previousRank - currentRank;
  if (diff > 0) {
    return <div className="flex items-center text-emerald-400 text-sm font-medium" data-id="element-251">
        <ChevronUp className="w-4 h-4 mr-0.5" data-id="element-252" />
        <span data-id="element-253">{diff}</span>
      </div>;
  }
  if (diff < 0) {
    return <div className="flex items-center text-rose-400 text-sm font-medium" data-id="element-254">
        <ChevronDown className="w-4 h-4 mr-0.5" data-id="element-255" />
        <span data-id="element-256">{Math.abs(diff)}</span>
      </div>;
  }
  return <div className="flex items-center text-slate-500 text-sm font-medium" data-id="element-257">
      <Minus className="w-4 h-4 mr-0.5" data-id="element-258" />
      <span data-id="element-259">-</span>
    </div>;
}